/**
 * Main.js
 *
 * @since 1.0.0
 */

import 'objectFitPolyfill'
import 'smoothscroll'
import objectFitImages from 'object-fit-images'
import * as Sentry from '@sentry/browser'
import ObserveFontFace from './modules/ObserveFontFace'
import FormValidation from './modules/FormValidation'
import StepsForm from './modules/StepsForm'
import SendForm from './modules/SendForm'
import DependsOn from './modules/DependsOn'
import LazyLoadVideo from './modules/LazyLoadVideo'
import Click from './modules/Click'
import UploadButton from './modules/UploadButton'
import Popup from './modules/Popup'
import StickyHeader from './modules/StickyHeader'
import MobileNav from './modules/MobileNav'
import Counter from './modules/Counter'
import Lightbox from './modules/Lightbox'
import Calculator from './modules/Calculator'
import StickyShare from './modules/StickyShare'
import Video from './modules/Video'
;(function IIFE() {
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn: 'https://02a83a1bc62349af91e151eb71ecd57f@sentry.io/2230400'
    })
  }
  ObserveFontFace()
  objectFitImages()
  Popup()
  FormValidation()
  SendForm()
  StepsForm()
  DependsOn()
  LazyLoadVideo()
  Click()
  StickyHeader()
  MobileNav()
  Counter()
  Lightbox()
  Calculator()
  UploadButton()
  Video()
  StickyShare()
})()



// WEBPACK FOOTER //
// ./src/js/main.js